import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { addCustomerPaymentMethodForClient } from "../redux/Slices/leadOfferSlice";

const StripeClientSuccess = () => {
  const dispatch = useDispatch();
  const [sessionId, setSessionId] = useState(
    localStorage.getItem("checkoutSessionId") || ""
  );
  const [leadOfferDetailsId] = useState(
    localStorage.getItem("payment_LeadOfferDetailsId") || ""
  );

  const { checkoutSession, loading, error } = useSelector(
    (state) => state.leadOffer
  );

  // Update sessionId if checkoutSession changes
  useEffect(() => {
    if (checkoutSession?.id) {
      setSessionId(checkoutSession.id);
    }
  }, [checkoutSession]);

  // Process payment method when sessionId is available
  useEffect(() => {
    if (sessionId && leadOfferDetailsId) {
      dispatch(
        addCustomerPaymentMethodForClient({ sessionId, leadOfferDetailsId })
      ).then((result) => {
        if (result.error) {
          console.error("Payment method addition failed:", result.error);
        } else {
          localStorage.removeItem("checkoutSessionId");
        }
      });
    }
  }, [dispatch, sessionId, leadOfferDetailsId]);

  if (loading) {
    return (
      <div className="flex flex-col items-center justify-center min-h-screen bg-blue-50">
        <div className="bg-white p-6 rounded-lg shadow-lg text-center">
          <h2>Processing your payment method...</h2>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="flex flex-col items-center justify-center min-h-screen bg-red-50">
        <div className="bg-white p-6 rounded-lg shadow-lg text-center">
          <h2 className="text-red-500">Error Saving Card Details</h2>
          <p className="text-red-500">{error}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-green-50">
      <div className="bg-white p-6 rounded-lg shadow-lg text-center">
        <h2 className="text-green-600 mb-4">
          Card Details Saved Successfully!
        </h2>
        <p className="text-gray-700">
          Your card details have been securely saved for future transactions.
          <br />
          Thank you for updating your payment information.
        </p>
      </div>
    </div>
  );
};

export default StripeClientSuccess;
